// @ts-check
// Temporary workaround until browsers get real import-maps

import * as _idb from "../../node_modules/idb/build/index.js";
import * as _webidl2 from "../../node_modules/webidl2/index.js";
import {
  GenericArguments as _CddlGenericArguments,
  GenericParameters as _CddlGenericParameters,
  Marker as _CddlMarker,
  Memberkey as _CddlMemberkey,
  Occurrence as _CddlOccurrence,
  Rule as _CddlRule,
  Type as _CddlType,
} from "../../node_modules/cddlparser/dist/ast.js";
import { Parser as _CddlParser } from "../../node_modules/cddlparser/dist/parser.js";
import { MIMEType as _MIMEType } from "../../node_modules/sniffy-mimetype/index.js";
import { marked as _marked } from "../../node_modules/marked/lib/marked.esm.js";
import _pluralize from "../../js/deps/builds/pluralize.js";
import hyperHTML from "../../node_modules/hyperhtml/esm.js";

// The runtime import above is by file path, which bypasses hyperhtml's
// index.d.ts, so `html` would otherwise be typed from the minified esm.js.
export const html = /** @type {typeof import("hyperhtml").default} */ (
  /** @type {unknown} */ (hyperHTML)
);
export const idb = _idb;
export const marked = _marked;
export const MIMEType = _MIMEType;
export const pluralize = _pluralize;
export const webidl2 = _webidl2;
export const CddlParser = _CddlParser;
export const CddlMarker = _CddlMarker;
export const CddlRule = _CddlRule;
export const CddlMemberkey = _CddlMemberkey;
export const CddlGenericParameters = _CddlGenericParameters;
export const CddlGenericArguments = _CddlGenericArguments;
export const CddlType = _CddlType;
export const CddlOccurrence = _CddlOccurrence;
